import Vue from "vue";
import { Component, Emit, Watch } from "vue-property-decorator";
import ValidatedFormGroup from "../../Default/common/validated-form-group.vue";
import ValidationMessage from "../../Default/common/validation-message.vue";
import StreetAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/street-autocomplete.vue";
import PostalAutocomplete from "../../../../../Scripts/vue-components/bootstrap-components/postal-autocomplete.vue";
import { ValidationErrors } from "../../new-contract-vue";
import { NewContractEvents } from "../../new-contract-vue-events";
import { IProductViewModel, IPriceListViewModel, IContractViewModel, IFinalInvoicingAddressViewModel, IMeteringPointViewModel } from "../../../../../Scripts/inpulse/I4UViewModels";
import { SectionChecker } from "../../Default/common/section";
import { ProcessTypeEnum, SubProcessTypeEnum } from "../../../../../Scripts/inpulse/CommonEnums";

class Checker extends SectionChecker {
    constructor() {
        super();
        this.properties = [
            (contract: IContractViewModel) => contract.ProcessType,
            (contract: IContractViewModel) => contract.SubProcessType,
        ];
    }
}
export const MoveOutProcessSelectorChecker = new Checker();

@Component({
    components: {
        ValidatedFormGroup,
        ValidationMessage,
        PostalAutocomplete,
        StreetAutocomplete,
    },
})

export default class MoveOutProcessSelector extends Vue {
    get contract(): IContractViewModel { return this.$store.state.contract; }
    selectProduct(payload: { productId: number, priceListId: number}) { return this.$store.commit("setConinueWithSameProductIdAndPricelistId", payload); }

    //@Prop()
    //public validationErrors: ValidationErrors;
    @Emit()
    processSelected() { }


    constructor() {
        super();
        console.log("MoveOutCompanySelection constructor");
    }

    mounted() {
        if (this.$store.state.isProcessTypeSelected == false) {
            this.newContractMode = 5; // ProcessTypeEnum.MOVEOUT
        }
        if (this.contract.ContractToNewAddressSelection != 0) {
            this.setNewContractModeSelection(this.contract.ContractToNewAddressSelection);
        }
    }

    ProcessTypeEnum: typeof ProcessTypeEnum = ProcessTypeEnum;
    SubProcessTypeEnum: typeof SubProcessTypeEnum = SubProcessTypeEnum;

    newContractMode: ProcessTypeEnum = 0; // ProcessTypeEnum.UNKNOWN

    //initializing: boolean = true;

    @Watch("newContractMode")
    newContractModeChanged(): void {
        this.$store.state.isProcessTypeSelected = true;
        this.processSelected();
        //// using CONTRACTPROCESS as a key and changing it to MOVINGPROCESS to actual value with subprocesstype
        //if (this.contract.ContractToNewAddressSelection != 0) {
        //    this.setNewContractModeSelection(this.contract.ContractToNewAddressSelection);
        //}
        if (this.newContractMode == 1) { // ProcessTypeEnum.CONTRACTPROCESS
            this.$store.dispatch("changeValue", { key: "SubProcessType", value: "2" }).then(() => {
                this.$store.dispatch("changeValue", { key: "ProcessType", value: "2" }).then(() => {
                    if (this.contract.MoveOutProcess && this.contract.MoveOutProcess.ConsumptionPoints) {
                        if (this.contract.MoveOutProcess.ConsumptionPoints.length == 1) {
                            let salescontract = this.contract.MoveOutProcess.ConsumptionPoints[0].MeteringPoints[0].Contracts.find(x => x.SourceCompanyCode == "PKSM");
                            let customerSalesContract = this.contract.CustomerContracts.find(x => x.ContractCode == salescontract.ContractCode && x.SourceCompanyCode == salescontract.SourceCompanyCode);
                            if (customerSalesContract) {

                                let prodId = customerSalesContract.ProductId;
                                let prListId = customerSalesContract.PriceListId;
                                if (prodId > 0 && prListId > 0) {
                                    this.selectProduct({ productId: prodId, priceListId: prListId });
                                }
                            }
                        }
                        else {
                            this.selectProduct({ productId: -1, priceListId: -1 });
                        }
                    }
                    console.log("continuing with old contract");
                });
            });
        }
        else {
            this.$store.dispatch("changeValue", { key: "SubProcessType", value: "1" }).then(() => {
                this.$store.dispatch("changeValue", { key: "ProcessType", value: this.newContractMode }).then(() => {
                    console.log("Process changed to" + this.newContractMode);
                });
            });
        }
    }

    public saveNewContractModeSelection(selection:number): void {
        this.$store.dispatch("changeValue", { key: "ContractToNewAddress", value: selection.toString() }).then(() => {
            console.log("saveNewContractModeSelection, dispatched ChangeValue ContractToNewAddress: " + selection);
            NewContractEvents.notifyNewContractInitialized();
        });
    }

    setNewContractModeSelection(newSelection: number): void {
        let newMode: number = 0;
        switch (newSelection) {
            case 1: {
                newMode = 2; // ProcessTypeEnum.MOVINGPROCESS
                break;
            }
            case 2: {
                newMode = 1; // ProcessTypeEnum.CONTRACTPROCESS
                break;
            }
            case 3: {
                newMode = 5;  // ProcessTypeEnum.MOVEOUT
                break;
            }

        }
        if (newMode != 0) {
            this.newContractMode = newMode;

        }
    }

}
